import f from "../funcs";
import $ from "jquery";
import Events from "../classes/Events";
import "plugins/hasChild";


const $window = $(window);
const FocusManager = Events.extend("FocusManager", {

    init(params, $elem) {
        params = f.deepMixin({
            // string or function
            // target is focusArea?
            check: false,

            defaultFocus: false,
            onBlur: false,
            onFocus: false
        }, params);
        this.params = params;

        if ( f.isString(params.check) ) {
            this.checkSelector = params.check;
        }
        if ( f.isFunction(params.check) ) {
            this.checkFunction = params.check.bind(this);
        }

        this.$elem = $elem;
        this.isFocus = params.defaultFocus;

        this.listenTo($window, "focusin mousedown touchend", this.onMousedown.bind(this));
    },

    onFocusin(e) {
        this.focus(e);
    },

    onMousedown(e) {
        if ( e.type == "focusin" ) {
            if ( e.target == window ) {
                return;
            }
        }


        let $target = $(e.target);
        let isFocusArea = (
            this.$elem[0] == e.target
                || this.$elem.hasChild($target)
                || this.checkSelector && $target.is(this.checkSelector)
                || this.checkSelector && $target.parents(this.checkSelector).length
                || this.checkFunction && this.checkFunction(e, $target)
        );

        if ( isFocusArea ) {
            this.focus(e);
        } else {
            this.blur(e);
        }
    },

    focus(e) {
        if ( !this.isFocus ) {
            this.isFocus = true;

            if ( f.isFunction(this.params.onFocus) ) {
                this.params.onFocus(e);
            }
            this.trigger("focus", e);
        }
    },

    blur(e) {
        if ( this.isFocus ) {
            this.isFocus = false;

            if ( f.isFunction(this.params.onBlur) ) {
                this.params.onBlur(e);
            }
            this.trigger("blur", e);
        }
    }
});


$.fn.focusManager = function(params) {
    let args = [].slice.call(arguments);

    return this.each(function() {
        let $elem = $(this);
        let focusManager = $elem.data("focusManager");

        if ( focusManager ) {
            if ( params === "focus" ) {
                focusManager.focus.apply(focusManager, args.slice(1));
            }
            else if ( params === "blur" ) {
                focusManager.blur.apply(focusManager, args.slice(1));
            }
            else if ( params === "destroy" ) {
                focusManager.destroy();
                $elem.data("focusManager", null);
            }
        }

        if ( f.isObject(params) ) {
            if ( focusManager ) {
                focusManager.destroy();
            }

            focusManager = new FocusManager(params, $elem);
            $elem.data("focusManager", focusManager);
        }
    });
};

export default FocusManager;
